import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {

  assets_data:any
  constructor(public apiService:ApiService,private activateRoute :ActivatedRoute,) {
    this.activateRoute.paramMap.subscribe(params => {
      let assets_id = params.get('id');
      this.getAssetsById(assets_id)
    })
   }

  ngOnInit(): void {
  }
getAssetsById(id){
      this.apiService.getAssetsById(id).subscribe((res:any)=>{
        if(res.statusCode === 200){
         this.assets_data = res?.data[0]
        }
      })
    }
}
